import { render, staticRenderFns } from "./GeneralCharts.vue?vue&type=template&id=3686be1a"
import script from "./GeneralCharts.vue?vue&type=script&lang=js"
export * from "./GeneralCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports